var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infinite-wrapper",attrs:{"id":"app"}},[_c('vue-progress-bar'),_c('notifications',{attrs:{"group":"main"}}),(_vm.loggedin && _vm.user)?_c('Frame'):_c('Login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }